import { X, Check, CircleAlert } from "lucide-react"

const True = ({size = 16}) => (
  <Check size={size} className="success-icon" />
)

export const False = ({size = 16}) => (
  <X size={size} className="error-icon" />
)

export const Undefined = ({size = 16}) => {
  <CircleAlert size={size} className="error-icon" />
}

export default function BooleanDisplay({value, size = 18}) {
  if (value === undefined || value === null)
    return <Undefined size={size} />
    
  return (
    value == true 
      ? <True size={size} />
      : <False size={size} />
  )
}